// src/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [credits, setCredits] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentlyGeneratingLesson, setCurrentlyGeneratingLesson] = useState(false);

  useEffect(() => {
    // We need to keep a reference to the snapshot unsubscribe function
    let unsubscribeSnapshot = () => {};

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);

      if (user) {
        // Subscribe to the user document for changes
        const userDocRef = doc(db, "users", user.uid);
        unsubscribeSnapshot = onSnapshot(userDocRef, (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            setCredits(data.credits || 0);
            setCurrentlyGeneratingLesson(data.currentlyGeneratingLesson || false);
          }
        });
      } else {
        setCredits(0);
        setCurrentlyGeneratingLesson(true);
      }
      setLoading(false);
    });

    // Cleanup both listeners when the component unmounts
    return () => {
      unsubscribeAuth();
      unsubscribeSnapshot();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, credits, currentlyGeneratingLesson }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
